import { dto_common } from "../classes/dto-common";
import { dto_Customer } from "../classes/dto-customer";
import { ENCRYPT_STORAGE } from "../config/config";
import { PUSHNOTIFICATIONURL, STORE_DeviceInfo, STORE_MobileCordinates, STORE_PUSHTOKEN } from "../database/store-names";

window.MOBILE_INTIGRATER = async (message) => {
  let rs = message.includes("Γ");
  if (rs === true) {
    let data = message.split("Γ");
    if (data[0].toUpperCase() === "PUSHTOKEN") {
      let objData = data[1].split("β");
      dto_Customer.PushToken = objData[0];
      dto_Customer.DeviceInfo = objData[1];
      ENCRYPT_STORAGE.setItem(STORE_PUSHTOKEN, objData[0]);
      ENCRYPT_STORAGE.setItem(STORE_DeviceInfo, objData[1]);
    }
    if (data[0].toUpperCase() === "LOCATION") {
      dto_common.MobileCordinate = data[1];
      ENCRYPT_STORAGE.setItem(STORE_MobileCordinates, data[1]);
    }
    //this is what i did today (08/02/2024  -- zee)
    if (data[0].toUpperCase() === "PUSHNOTIFICATIONURL") {
      if (data[1] !== "NOTHING") {
        if (data[1]) {
          let ObjUrl = JSON.parse(data[1])
          if (ObjUrl.url) {
            ENCRYPT_STORAGE.setItem(PUSHNOTIFICATIONURL, ObjUrl.url);
          }
        }
      }
    }
  }
};

export const REQUEST_PUSHTOKEN = async () => {
  window.ReactNativeWebView?.postMessage("PUSHTOKEN");
};

export const REQUEST_LOCATION = async () => {
  window.ReactNativeWebView?.postMessage("LOCATION");
};

export const REQUEST_SETTINGS = async () => {
  window.ReactNativeWebView?.postMessage("SETTINGS");
};

//this is what i did today (08/02/2024  -- zee)
export const REQUEST_DEEPLINK = async () => {
  window.ReactNativeWebView?.postMessage("PUSHNOTIFICATIONURL");
};